module.exports = __webpack_public_path__ + "img/chavesverin.0257cf0e.png";